import '../css/Zodiak.css'; // Import CSS untuk styling
import React, { useState } from 'react';
import axios from 'axios';
import { Container, Grid, Card, CardMedia, CardContent, Typography, Button, CircularProgress, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

// Import gambar zodiak dari direktori lokal
import ariesImage from '../images/aries.png';
import taurusImage from '../images/taurus.png';
import geminiImage from '../images/gemini.png';
import cancerImage from '../images/cancer.png';
import leoImage from '../images/leo.png';
import virgoImage from '../images/virgo.png';
import libraImage from '../images/libra.png';
import scorpioImage from '../images/scorpio.png';
import sagittariusImage from '../images/sagitarius.png';
import capricornImage from '../images/capricon.png';
import aquariusImage from '../images/aquarius.png';
import piscesImage from '../images/pisces.png';

const zodiakData = [
  { name: 'Aries', dateRange: '21 Maret - 19 April', icon: ariesImage },
  { name: 'Taurus', dateRange: '20 April - 20 Mei', icon: taurusImage },
  { name: 'Gemini', dateRange: '21 Mei - 20 Juni', icon: geminiImage },
  { name: 'Cancer', dateRange: '21 Juni - 22 Juli', icon: cancerImage },
  { name: 'Leo', dateRange: '23 Juli - 22 Agustus', icon: leoImage },
  { name: 'Virgo', dateRange: '23 Agustus - 22 September', icon: virgoImage },
  { name: 'Libra', dateRange: '23 September - 22 Oktober', icon: libraImage },
  { name: 'Scorpio', dateRange: '23 Oktober - 21 November', icon: scorpioImage },
  { name: 'Sagittarius', dateRange: '22 November - 21 Desember', icon: sagittariusImage },
  { name: 'Capricorn', dateRange: '22 Desember - 19 Januari', icon: capricornImage },
  { name: 'Aquarius', dateRange: '20 Januari - 18 Februari', icon: aquariusImage },
  { name: 'Pisces', dateRange: '19 Februari - 20 Maret', icon: piscesImage },
];

const StyledButton = styled(Button)(({ theme, active }) => ({
  fontSize: '1rem',
  padding: theme.spacing(1, 2),
  margin: theme.spacing(1),
  ...(active && {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  }),
  borderRadius: '4px',
}));

const StyledCard = styled(Card)(({ theme, selected }) => ({
  textAlign: 'center',
  boxShadow: theme.shadows[4],
  border: selected ? `2px solid ${theme.palette.primary.main}` : 'none',
  transition: 'transform 0.3s ease, box-shadow 0.3s ease, border 0.3s ease',
  '&:hover': {
    transform: 'scale(1.05)',
    boxShadow: theme.shadows[6],
  },
  borderRadius: '8px',
}));

const CardImage = styled(CardMedia)(({ theme }) => ({
  height: '150px',
  width: 'auto',
  margin: theme.spacing(2, 'auto'),
}));

function Zodiak() {
  const [selectedSign, setSelectedSign] = useState('');
  const [horoscope, setHoroscope] = useState('');
  const [loading, setLoading] = useState(false);
  const [period, setPeriod] = useState('daily'); // Default to daily

  const handleClick = async (sign) => {
    setLoading(true);
    setSelectedSign(sign);
    try {
      const response = await axios.post('http://192.168.1.6:8080/zodiakid_backend/api/zodiak.php', {
        sign: sign.toLowerCase(),
        period: period,
      });
      const data = response.data[sign];
      setHoroscope(data?.horoscope_data || 'No data available');
    } catch (error) {
      console.error('Error fetching horoscope:', error);
      alert('Failed to fetch horoscope');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Typography
        variant="h3"
        align="center"
        gutterBottom
        sx={{ mb: 6 }} // Add margin-bottom to create space below the header
      >
        Check Your Zodiac
      </Typography>

      <Grid container spacing={2} justifyContent="center" sx={{ mb: 4 }}>
        {['daily', 'weekly', 'monthly'].map(periodOption => (
          <Grid item key={periodOption}>
            <StyledButton
              variant={period === periodOption ? 'contained' : 'outlined'}
              active={period === periodOption}
              onClick={() => setPeriod(periodOption)}
            >
              {periodOption.charAt(0).toUpperCase() + periodOption.slice(1)}
            </StyledButton>
          </Grid>
        ))}
      </Grid>

      <Grid container spacing={2} justifyContent="center">
        {zodiakData.map(zodiak => (
          <Grid item key={zodiak.name} xs={12} sm={6} md={4} lg={3}>
            <StyledCard 
              selected={selectedSign === zodiak.name.toLowerCase()}
              onClick={() => handleClick(zodiak.name.toLowerCase())}
            >
              <CardImage
                component="img"
                image={zodiak.icon}
                alt={zodiak.name}
              />
              <CardContent>
                <Typography variant="h6">{zodiak.name}</Typography>
                <Typography variant="body2" color="textSecondary">{zodiak.dateRange}</Typography>
              </CardContent>
            </StyledCard>
          </Grid>
        ))}
      </Grid>

      {loading && (
        <Typography variant="h6" align="center" sx={{ mt: 4 }}>
          <CircularProgress /> Loading...
        </Typography>
      )}

      {horoscope && (
        <Box sx={{ mt: 4, p: 2, border: '1px solid #ddd', borderRadius: 2, bgcolor: '#f9f9f9' }}>
          <Typography variant="h4" align="center" gutterBottom>
            {selectedSign.charAt(0).toUpperCase() + selectedSign.slice(1)} Horoscope
          </Typography>
          <Typography variant="body1" sx={{ fontSize: '1.2rem', lineHeight: 1.5 }}>
            {horoscope}
          </Typography>
        </Box>
      )}
    </Container>
  );
}

export default Zodiak;
